<template>
  <span>{{ value | date }}</span>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Object],
      default: "",
    },
  },
};
</script>
